import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { Translator } from "./";
import { Bridge } from "./bridge";
export var Authenticator = /*#__PURE__*/function () {
  function Authenticator() {
    _classCallCheck(this, Authenticator);
  }
  _createClass(Authenticator, null, [{
    key: "isAnonymousAccessible",
    value: function isAnonymousAccessible(pathname) {
      return Authenticator.anonymousAccessiblePaths.some(function (path) {
        return pathname.match(path);
      });
    }

    /**
     * @description -
     */
  }, {
    key: "redirect",
    value: function redirect() {
      var persist = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      // -
      // > -
      var _window = window,
        _window$location = _window.location,
        search = _window$location.search,
        pathname = _window$location.pathname;
      // > -
      var key = "JiShuXin['Authenticator']['redirect']";
      // -
      if (Authenticator.isAnonymousAccessible(pathname)) {
        // 解析跳转参数
        var parameters = new URLSearchParams(search);
        // -
        Bridge.history.push(parameters.get('redirect') || sessionStorage.getItem(key) || '/');
      } else {
        // -
        var to = "".concat(pathname).concat(search);
        // -
        if (persist === true) {
          // -
          window.sessionStorage.setItem(key, to);
          // -
          Bridge.history.push(Authenticator.anonymousLoginPath);
        } else {
          // 构建跳转参数
          var _parameters = new URLSearchParams({
            redirect: to
          });
          // -
          Bridge.history.push("".concat(Authenticator.anonymousLoginPath, "?").concat(_parameters.toString()));
        }
      }
    }

    /**
     * @description -
     */
  }, {
    key: "isFeatureAvailable",
    value: (function () {
      var _isFeatureAvailable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(type) {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = type;
              _context.next = _context.t0 === 'credential' ? 3 : 8;
              break;
            case 3:
              if (!window.PublicKeyCredential) {
                _context.next = 7;
                break;
              }
              return _context.abrupt("return", window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable().then(function (result) {
                if (result) {
                  return Promise.resolve();
                } else {
                  return Promise.reject(Translator.formatMessage({
                    id: 'Your device'
                  }));
                }
              }));
            case 7:
              return _context.abrupt("return", Promise.reject(Translator.formatMessage({
                id: 'Your browser'
              })));
            case 8:
              return _context.abrupt("return", Promise.resolve());
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function isFeatureAvailable(_x) {
        return _isFeatureAvailable.apply(this, arguments);
      }
      return isFeatureAvailable;
    }())
  }]);
  return Authenticator;
}();
_defineProperty(Authenticator, "anonymousAccessiblePaths", [/\/authentication\/[\s\S]*?$/i, /\/user\/(login|recover\x2Dpassword|register)$/i]);
_defineProperty(Authenticator, "anonymousLoginPath", '/authentication/login');